// Draws one DrawFrame as SVG. Used live on screen and, through renderToStaticMarkup, for every export frame.
// The wiggle ("boil") is fractal-noise displacement whose pattern steps through 4 seeds, one step every few frames.
import { FRAME_H, FRAME_W } from "../engine/camera";
import type { DrawFrame } from "../engine/frame";
import { imageSrc } from "../library/images";

const SEEDS = [3, 11, 23, 37];

export function FrameSvg({ frame, id = "frame", boil = true, width, height }: { frame: DrawFrame; id?: string; boil?: boolean; width?: number; height?: number }) {
  const { view } = frame;
  // The camera goes inside the filter, so the boil's noise stays the same size on screen at any zoom.
  const camera = `scale(${FRAME_W / view.w}) translate(${-view.x} ${-view.y})`;
  const b = boil && frame.boil;
  const filter = `${id}-boil`;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox={`0 0 ${FRAME_W} ${FRAME_H}`} width={width} height={height} preserveAspectRatio="xMidYMid slice"
      style={{ display: "block", width: width ? undefined : "100%", height: height ? undefined : "100%" }}>
      {b && (
        <defs>
          <filter id={filter} x="-5%" y="-5%" width="110%" height="110%">
            <feTurbulence type="fractalNoise" baseFrequency={0.03} numOctaves={2} seed={SEEDS[Math.floor(frame.frame / Math.max(1, b.every)) % SEEDS.length]} result="noise" />
            <feDisplacementMap in="SourceGraphic" in2="noise" scale={b.strength} xChannelSelector="R" yChannelSelector="G" />
          </filter>
        </defs>
      )}
      <rect width={FRAME_W} height={FRAME_H} style={{ fill: frame.base }} /> {/* a style, so theme variables work on screen */}
      <g filter={b ? `url(#${filter})` : undefined}>
        <g transform={camera}>
          {frame.images.map((p, i) => (
            <image key={i} href={imageSrc(p.href)} x={p.x} y={p.y} width={p.w} height={p.h} preserveAspectRatio="none"
              transform={[p.rot ? `rotate(${p.rot} ${p.x + p.w / 2} ${p.y + p.h / 2})` : "", p.flip ? `translate(${2 * p.x + p.w} 0) scale(-1 1)` : ""].join(" ").trim() || undefined} />
          ))}
        </g>
      </g>
    </svg>
  );
}
